import { getConfig } from '@testing-library/react';
import Core from '../core';

function getdashboardService(empId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/getEmployeeDetail?empId=${empId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getDashboardCalendarData(companyId: number, empId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/getEmployeeLeavesCalandar?company_id=${companyId}&emp_id=${empId}&month=12&year=2022`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getcheckclockinandoutEnable(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`/v1/attendanceconfig?company_id=${companyId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response?.data?.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getUserInfo(userId: number, locale: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`v1/employee/getRollPermission?user_id=${userId}&locale=${locale}`)
      .then((response) => {
        return resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getConfigMenuList(userId: number, locale: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`v2/config/empportalMenu/config`)
      .then((response) => {
        return resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const dashboardService = {
  getdashboardService,
  getDashboardCalendarData,
  getcheckclockinandoutEnable,
  getUserInfo,
  getConfigMenuList,
};
